import Banner from '@rio-cloud/rio-uikit/Banner';
import type React from 'react';
import { useEffect, useState } from 'react';

import { loadFromLocalStorage, saveInLocalStorage } from '../onboarding/handleLocalStorage';

interface DismissableBannerProps {
    storageKey: string;
    icon?: React.ReactNode;
    title: string | React.ReactElement;
    children: React.ReactNode;
    border?: boolean;
    shouldShow?: boolean;
    className?: string;
}

export const DismissableBanner: React.FC<DismissableBannerProps> = ({
    storageKey,
    icon,
    title,
    children,
    border = false,
    shouldShow = true,
    className,
}) => {
    const [showBanner, setShowBanner] = useState(() => {
        if (!shouldShow) {
            return false;
        }
        const dismissed = loadFromLocalStorage(storageKey);
        return !dismissed;
    });

    useEffect(() => {
        if (shouldShow && !showBanner) {
            const dismissed = loadFromLocalStorage(storageKey);
            if (!dismissed) {
                setShowBanner(true);
            }
        }
        if (!shouldShow && showBanner) {
            setShowBanner(false);
        }
    }, [shouldShow, storageKey]);

    const handleClose = () => {
        setShowBanner(false);
        saveInLocalStorage(storageKey, true);
    };

    if (!shouldShow) {
        return null;
    }

    return (
        <div className={className}>
            <Banner show={showBanner} onClose={handleClose} border={border}>
                <Banner.Page>
                    {icon && <Banner.Icon className='text-size-14'>{icon}</Banner.Icon>}
                    <Banner.Content title={title}>{children}</Banner.Content>
                </Banner.Page>
            </Banner>
        </div>
    );
};
